/* src/app/app.component.scss */
:host {
  background: var(--app-background);
}
:host ion-app {
  background: var(--app-background);
  background-size: cover;
}
/*# sourceMappingURL=app.component-MTYVCKTM.css.map */
